// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rDNA-chartHeader {
  display: flex;
  flex-direction: row;
}

@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.rDNA-chartHeader .rDNA-subheader, .rDNA-chartHeader .rDNA-header {
  font-family: "Dm Sans", sans-serif;
  font-size: 16px;
  font-weight: 700;
  font-style: normal;
}

/** Colors variables */
.sb-default .sb-wrapper {
  --sb-color: #fff;
  --sb-background: var(--button-color);
  --sb-border-radius: 4px;
  --sb-overflow: hidden;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text {
  --sb-text-padding: 0 1em 0 0;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text .sb-text {
  filter: none;
}

/** Colors variables */
.sb-circles-dark .sb-wrapper, .sb-circles-light .sb-wrapper {
  --sb-color: #fff;
  --sb-background: transparent;
  --sb-min-width: fit-content;
  --sb-height: fit-content;
  --sb-icon-size: 1.4em;
}
.sb-circles-dark .sb-wrapper:active .sb-icon, .sb-circles-light .sb-wrapper:active .sb-icon {
  box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14), 0 5px 22px 4px rgba(0, 0, 0, 0.12);
}
.sb-circles-dark .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-icon {
  background-color: var(--button-color);
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 2.5em;
  min-height: 2.5em;
  border-radius: 50%;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-text, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
  font-size: 0.8em;
  margin-top: 5px;
  border-radius: 1em;
  width: 100%;
  height: 1.8em;
  line-height: 1.8em;
  padding: 0;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-content, .sb-circles-light .sb-wrapper .sb-content {
  align-items: center;
  flex-direction: column;
}

.sb-circles-dark .sb-wrapper .sb-icon {
  background-color: var(--button-color);
}
.sb-circles-dark .sb-wrapper .sb-text {
  color: var(--button-color);
}

.sb-circles-light .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
}
.sb-circles-light .sb-wrapper .sb-icon {
  background: radial-gradient(ellipse farthest-corner at center, white 30%, #f2f2f2 100%);
}

/* You can add global styles to this file, and also import other style files */
body, html {
  height: 100vh;
  margin: 0;
}

body {
  font-family: Arial, sans-serif;
  height: 100vh;
  background-color: #fff; /* Background color for the top half */
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
}

body::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background: #fff;
  z-index: -1; /* Ensure the gradient is behind other content */
}

/* Old palette
\$theme-main: #B05995;
\$theme-contrast: #3792BF;
\$theme-1: #282B59;
\$theme-2: #D683DD;
\$theme-3: #27567A;
\$theme-4: #44DDC4;
\$theme-5: #3336AE;
\$theme-6: #18C43D;
*/
.material-symbols-outlined {
  cursor: pointer;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 48;
}

p {
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  color: #2D2D2A;
}

html, body {
  height: 100%;
}

body {
  margin: 0;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.generic-button, .generic-button-alt {
  color: white;
  border-radius: 5px; /* Rounded corners */
  padding: 10px 20px; /* Padding for button size */
  margin-right: 10px;
  cursor: pointer; /* Pointer on hover */
  transition: background-color 0.3s; /* Smooth transition on hover */
}
.generic-button p, .generic-button-alt p {
  color: white;
  margin: 0;
}

.generic-button {
  background-color: #1B3E78; /* Button background color */
  border: 2px solid #1B3E78; /* No border */
}

.generic-button-alt {
  background-color: #0CAD99; /* Button background color */
  border: 2px solid #0CAD99; /* No border */
}

.generic-button:hover {
  background-color: #fff; /* Change color on hover */
  color: #1B3E78;
}
.generic-button:hover p {
  color: #1B3E78;
}

.generic-button-alt:hover {
  background-color: #fff; /* Change color on hover */
  color: #0CAD99;
}
.generic-button-alt:hover p {
  color: #0CAD99;
}

.generic-button:disabled, .generic-button-alt:disabled {
  background-color: #e7e7e7;
  border-color: #e7e7e7;
  cursor: not-allowed;
}

.rDNA-chartHeader {
  align-items: flex-end;
  border-bottom: 5px solid #1B3E78;
  margin-bottom: 15px;
}
.rDNA-chartHeader .rDNA-chartHeadLeft {
  flex: 1;
  margin-bottom: 5px;
}
.rDNA-chartHeader .rDNA-header {
  margin: 0;
  color: #1B3E78;
}
.rDNA-chartHeader .rDNA-subheader {
  margin: 0;
  color: #0CAD99;
}
.rDNA-chartHeader .rDNA-header[contenteditable=true],
.rDNA-chartHeader .rDNA-subheader[contenteditable=true] {
  background-color: #fcf8e3 !important; /* Light yellow */
  border: 1px solid #ff5733 !important; /* Orange */
  padding: 5px; /* Optional: Adds spacing */
}
.rDNA-chartHeader .rDNA-chartHeadLogo {
  position: relative !important;
  max-width: 120px;
}
.rDNA-chartHeader .rDNA-chartHeaderRight {
  height: 45px;
  margin-bottom: 5px;
  flex: 0 0 auto;
  max-width: 120px;
}

@media screen and (max-width: 767.7px) {
  .rDNA-chartHeader .rDNA-header {
    font-size: 12px;
  }
  .rDNA-chartHeader .rDNA-subheader {
    font-size: 12px;
  }
  .rDNA-chartHeader .rDNA-chartHeadLeft {
    margin-right: 25px;
  }
}
@media screen and (max-width: 1023.7px) and (min-width: 768px) {
  .rDNA-chartHeader .rDNA-header {
    font-size: 14px;
  }
  .rDNA-chartHeader .rDNA-subheader {
    font-size: 14px;
  }
}
@media screen and (max-width: 1199.7px) and (min-width: 1024px) {
  .rDNA-chartHeader .rDNA-header {
    font-size: 14px;
  }
  .rDNA-chartHeader .rDNA-subheader {
    font-size: 14px;
  }
}
@media screen and (max-width: 1439.7px) and (min-width: 1200px) {
  .rDNA-chartHeader .rDNA-header {
    font-size: 14px;
  }
  .rDNA-chartHeader .rDNA-subheader {
    font-size: 14px;
  }
}
@media screen and (min-width: 1440px) {
  .rDNA-chartHeader .rDNA-header {
    font-size: 16px;
  }
  .rDNA-chartHeader .rDNA-subheader {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/placeholders/_flexboxes.scss","webpack://./src/app/shared/toolbox/charts/chart-header/chart-header.component.scss","webpack://./src/theme/fonts.scss","webpack://./src/theme/variables.scss","webpack://./src/theme/placeholders/_fonts.scss","webpack://./src/theme/mixins.scss","webpack://./node_modules/ngx-sharebuttons/themes/variables.scss","webpack://./node_modules/ngx-sharebuttons/themes/default.scss","webpack://./node_modules/ngx-sharebuttons/themes/circles.scss","webpack://./src/styles.scss"],"names":[],"mappings":"AAMA;EAC0B,aAAA;EACA,mBAAA;ACL1B;;ACHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADMF;ACHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ADKF;ACFA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADIF;ACDA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ADGF;ACAA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ADEF;ACCA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ADCF;ACEA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADAF;ACGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADDF;ACIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADFF;ACKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ADHF;ACMA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ADJF;ACOA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADLF;ACQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;ADNF;ACSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;ADPF;ACUA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ADRF;ACWA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ADTF;ACYA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ADVF;ACaA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADXF;AEzGA;;;;;uBAAA;ADPA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADwHF;ACrHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ADuHF;ACpHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADsHF;ACnHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ADqHF;AClHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ADoHF;ACjHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ADmHF;AChHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADkHF;AC/GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADiHF;AC9GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADgHF;AC7GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AD+GF;AC5GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;AD8GF;AC3GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AD6GF;AC1GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;AD4GF;ACzGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AD2GF;ACxGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AD0GF;ACvGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ADyGF;ACtGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ADwGF;ACrGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADuGF;AE3NA;;;;;uBAAA;ACaA;ECJE,kCFXY;EEYZ,eDG2C;ECF3C,gBATiF;EAUjF,kBALgB;AJgOlB;;AK9OA,sBAAA;ACEA;EACE,gBAAA;EACA,oCAAA;EACA,uBAAA;EACA,qBAAA;ANgPF;AM9OE;EACE,4BAAA;ANgPJ;AM9OI;EACE,YAAA;ANgPN;;AK5PA,sBAAA;AEME;EACE,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qBAAA;AP0PJ;AOvPM;EACE,sHAAA;APyPR;AOrPI;EACE,qCAAA;EACA,iHAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,2GAAA;APuPN;AOpPI;EACE,0BAAA;EACA,gBA3BS;EA4BT,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,2GAAA;APsPN;AOnPI;EACE,mBAAA;EACA,sBAAA;APqPN;;AO9OE;EACE,qCAAA;APiPJ;AO9OE;EACE,0BAAA;APgPJ;;AO1OE;EACE,0BAAA;AP6OJ;AO1OE;EACE,uFAAA;AP4OJ;;AQzSA,8EAAA;AAEA;EACA,aAAA;EAEA,SAAA;AR0SA;;AQvSA;EACI,8BAAA;EACA,aAAA;EACA,sBAAA,EAAA,sCAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;AR0SJ;;AQtSA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EAGA,WAAA,EAAA,gDAAA;ARuSJ;;AQlSA;;;;;;;;;CAAA;AA0CA;EAEI,eAAA;EACA,kEACI;ARmQR;;AQ7PA;EACI,yCAAA;EACA,mBAAA;EACA,cAxDS;ARwTb;;AQ3PA;EAAa,YAAA;AR+Pb;;AQ9PA;EAAO,SAAA;EAAW,iDAAA;ARmQlB;;AQhQA;EACE,YAAA;EACA,kBAAA,EAAA,oBAAA;EACE,kBAAA,EAAA,4BAAA;EACA,kBAAA;EAGA,eAAA,EAAA,qBAAA;EACA,iCAAA,EAAA,+BAAA;ARiQJ;AQ/PI;EACI,YAAA;EACA,SAAA;ARiQR;;AQ9PA;EACE,yBArEW,EAqEoB,4BAAA;EAC/B,yBAAA,EAAA,cAAA;ARiQF;;AQ9PA;EACE,yBA7Da,EA6DoB,4BAAA;EACjC,yBAAA,EAAA,cAAA;ARiQF;;AQ9PA;EACI,sBAAA,EAAA,0BAAA;EACA,cAhFS;ARiVb;AQ/PI;EACI,cAnFK;ARoVb;;AQ7PA;EACE,sBAAA,EAAA,0BAAA;EACA,cA5Ea;AR4Uf;AQ9PE;EACE,cA/EW;AR+Uf;;AQ5PA;EACI,yBA/Ec;EAgFd,qBAhFc;EAiFd,mBAAA;AR+PJ;;AA3YA;EAEE,qBAAA;EACA,gCAAA;EACA,mBAAA;AA6YF;AA3YE;EACE,OAAA;EACA,kBAVS;AAuZb;AA3YE;EACE,SAAA;EAEA,cENQ;AFkZZ;AA1YE;EACE,SAAA;EAEA,cQoCW;ARuWf;AAxYE;;EAEE,oCAAA,EAAA,iBAAA;EACA,oCAAA,EAAA,WAAA;EACA,YAAA,EAAA,2BAAA;AA0YJ;AAvYE;EACE,6BAAA;EACA,gBAAA;AAyYJ;AAvYE;EACE,YAAA;EACA,kBApCS;EAqCT,cAAA;EACA,gBAAA;AAyYJ;;AArYA;EAEI;IAAe,eAAA;EAwYjB;EAvYE;IAAkB,eAAA;EA0YpB;EAzYE;IAAsB,kBAAA;EA4YxB;AACF;AAzYA;EAEI;IAAe,eAAA;EA2YjB;EA1YE;IAAkB,eAAA;EA6YpB;AACF;AA1YA;EAEI;IAAe,eAAA;EA4YjB;EA3YE;IAAkB,eAAA;EA8YpB;AACF;AA3YA;EAEI;IAAe,eAAA;EA6YjB;EA5YE;IAAkB,eAAA;EA+YpB;AACF;AA5YA;EAEI;IAAe,eAAA;EA8YjB;EA7YE;IAAkB,eAAA;EAgZpB;AACF","sourcesContent":["\n%flex-column            {\n                          display: flex;\n                          flex-direction: column;\n                        }\n\n%flex-row               {\n                          display: flex;\n                          flex-direction: row;\n                        }\n\n%flex-jCenter-aCenter   {\n                          justify-content: center;\n                          align-items: center;\n                        }\n\n%flex-jCenter-aStart    {\n                          justify-content: center;\n                          align-items: flex-start;\n                        }\n\n%flex-jCenter-aEnd      {\n                          justify-content: center;\n                          align-items: flex-end;\n                        }\n\n%flex-jStart-aCenter    {\n                          justify-content: flex-start;\n                          align-items: center;\n                        }\n\n%flex-jStart-aStart     {\n                          justify-content: flex-start;\n                          align-items: flex-start;\n                        }\n\n%flex-jStart-aEnd       {\n                          justify-content: flex-start;\n                          align-items: flex-end;\n                        }\n\n%flex-jEnd-aCenter      {\n                          justify-content: flex-end;\n                          align-items: center;\n                        }\n\n%flex-jEnd-aStart       {\n                          justify-content: flex-end;\n                          align-items: flex-start;\n                        }\n\n%flex-jEnd-aEnd         {\n                          justify-content: flex-end;\n                          align-items: flex-end;\n                        }\n\n","@import \"placeholders/flexboxes\";\n@import \"variables\";\n@import \"placeholders/fonts\";\n@import \"variables/breakpoints\";\n@import \"./../../../../../styles.scss\";\n\n$box-margin: 5px;\n\n.rDNA-chartHeader {\n  @extend %flex-row;\n  align-items: flex-end;\n  border-bottom: 5px solid $dark-text;\n  margin-bottom: 15px;\n\n  .rDNA-chartHeadLeft {\n    flex: 1;\n    margin-bottom: $box-margin;\n  }\n  .rDNA-header {\n    margin: 0;\n    @extend %font-16px-bold;\n    color: $dark-text;\n  }\n  .rDNA-subheader {\n    margin: 0;\n    @extend %font-16px-bold;\n    color: $theme-accent;\n  }\n\n  .rDNA-header[contenteditable=\"true\"],\n  .rDNA-subheader[contenteditable=\"true\"] {\n    background-color: #fcf8e3 !important; /* Light yellow */\n    border: 1px solid #ff5733 !important; /* Orange */\n    padding: 5px; /* Optional: Adds spacing */\n  }\n\n  .rDNA-chartHeadLogo {\n    position: relative !important;\n    max-width: 120px;\n   }\n  .rDNA-chartHeaderRight {\n    height: 45px;\n    margin-bottom: $box-margin;\n    flex: 0 0 auto; // Prevent from growing or shrinking\n    max-width:120px;\n  }\n}\n\n@media screen and (max-width: $breakpoint-sm-max ) {\n  .rDNA-chartHeader {\n    .rDNA-header { font-size: 12px; }\n    .rDNA-subheader { font-size: 12px; }\n    .rDNA-chartHeadLeft { margin-right: 25px; }\n  }\n}\n\n@media screen and (max-width: $breakpoint-md-max ) and (min-width: $breakpoint-md-min) {\n  .rDNA-chartHeader {\n    .rDNA-header { font-size: 14px; }\n    .rDNA-subheader { font-size: 14px; }\n  }\n}\n\n@media screen and (max-width: $breakpoint-lg-max ) and (min-width: $breakpoint-lg-min) {\n  .rDNA-chartHeader {\n    .rDNA-header { font-size: 14px; }\n    .rDNA-subheader { font-size: 14px; }\n  }\n}\n\n@media screen and (max-width: $breakpoint-xl-max ) and (min-width: $breakpoint-xl-min) {\n  .rDNA-chartHeader {\n    .rDNA-header { font-size: 14px; }\n    .rDNA-subheader { font-size: 14px; }\n  }\n}\n\n@media screen and (min-width: $breakpoint-xxl-min ) {\n  .rDNA-chartHeader {\n    .rDNA-header { font-size: 16px; }\n    .rDNA-subheader { font-size: 16px; }\n  }\n}\n","@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n","@import '../mixins';\n\n/////////////////////////////////////\n//   Extra Bold Font Placeholders  //\n/////////////////////////////////////\n\n%font-16px-extra-bold { @include format-font(16px, 'extra bold'); }\n\n/////////////////////////////////////\n//     Bold Font Placeholders     //\n/////////////////////////////////////\n\n%font-52px-bold       { @include format-font(52px, 'bold'); }\n%font-48px-bold       { @include format-font(48px, 'bold'); }\n%font-34px-bold       { @include format-font(34px, 'bold'); }\n%font-32px-bold       { @include format-font(32px, 'bold'); }\n%font-28px-bold       { @include format-font(28px, 'bold'); }\n%font-24px-bold       { @include format-font(24px, 'bold'); }\n%font-20px-bold       { @include format-font(20px, 'bold'); }\n%font-18px-bold       { @include format-font(18px, 'bold'); }\n%font-16px-bold       { @include format-font(16px, 'bold'); }\n%font-14px-bold       { @include format-font(14px, 'bold'); }\n%font-12px-bold       { @include format-font(12px, 'bold'); }\n\n\n/////////////////////////////////////\n//   Semi-Bold Font Placeholders   //\n/////////////////////////////////////\n\n%font-24px-semi       { @include format-font(24px, 'semi-bold'); }\n%font-20px-semi       { @include format-font(20px, 'semi-bold'); }\n\n\n/////////////////////////////////////\n//     Medium Font Placeholders    //\n/////////////////////////////////////\n\n%font-30px-medium     { @include format-font(30px, 'medium'); }\n%font-20px-medium     { @include format-font(20px, 'medium'); }\n%font-18px-medium     { @include format-font(18px, 'medium'); }\n%font-16px-medium     { @include format-font(16px, 'medium'); }\n%font-14px-medium     { @include format-font(14px, 'medium'); }\n%font-12px-medium     { @include format-font(12px, 'medium'); }\n%font-10px-medium     { @include format-font(10px, 'medium'); }\n\n/////////////////////////////////////\n//    Normal Font Placeholders     //\n/////////////////////////////////////\n\n%font-18px-normal     { @include format-font(18px); }\n%font-16px-normal     { @include format-font(16px); }\n%font-14px-normal     { @include format-font(14px); }\n%font-12px-normal     { @include format-font(12px); }\n","@import 'variables';\n\n@mixin format-font($size, $weight: 500, $style: 'normal' ) {\n  @if ( $weight == 'thin' or $weight == 'Thin' ) { $weight: 100; }\n  @else if ( $weight == 'extra light' or $weight == 'Extra light' or $weight == 'extra Light' or $weight == 'Extra Light' or  $weight == 'el') { $weight: 200; }\n  @else if ( $weight == 'light' or $weight == 'Light'  or $weight == 'l') { $weight: 300; }\n  @else if ( $weight == 'normal' or $weight == 'Normal'  or $weight == 'n') { $weight: 400; }\n  @else if ( $weight == 'medium' or $weight == 'Medium'  or $weight == 'm') { $weight: 500; }\n  @else if ( $weight == 'semi-bold' or $weight == 'Semi-bold' or $weight == 'semi-Bold' or $weight == 'Semi-Bold' or $weight == 'sb' ) { $weight: 600; }\n  @else if ( $weight == 'bold' or $weight == 'Bold' or $weight == 'b' ) { $weight: 700; }\n  @else if ( $weight == 'extra bold' or $weight == 'Extra bold' or $weight == 'extra Bold' or $weight == 'Extra Bold' or $weight == 'eb' ) { $weight: 800; }\n  @else if ( $weight == 'black' or $weight == 'Black' or $weight == 'blk') { $weight: 900; }\n\n  @if ( $style == 'Italic' or $style == 'i' ) { $style: italic; }\n  @else { $style: normal; }\n\n  font-family: $font-family;\n  font-size: $size;\n  font-weight: $weight;\n  font-style: $style;\n}\n","/** Colors variables */\r\n\r\n$sb-primary: #2E4057 !default;\r\n$sb-accent: #fff !default;\r\n$sb-facebook: #4267B2 !default;\r\n$sb-twitter: #00acee !default;\r\n$sb-google: #db4437 !default;\r\n$sb-mix: #ff8226 !default;\r\n$sb-linkedin: #006fa6 !default;\r\n$sb-pinterest: #bd081c !default;\r\n$sb-reddit: #ff4006 !default;\r\n$sb-tumblr: #36465d !default;\r\n$sb-whatsapp: #25d366 !default;\r\n$sb-messenger: #0080FF !default;\r\n$sb-telegram: #0088cc !default;\r\n$sb-xing: #006567 !default;\r\n$sb-email: #FF961C !default;\r\n$sb-viber: #665ca7 !default;\r\n$sb-vk: #4C75A3 !default;\r\n$sb-copy: #607D8B !default;\r\n$sb-print: #765AA2 !default;\r\n$sb-sms: #20c16c !default;\r\n$sb-gray: #a5a5a5 !default;\r\n$sb-expand: #FF6651 !default;\r\n$sb-line: #00b900 !default;\r\n\r\n$sb-buttons: (\r\n  facebook: $sb-facebook,\r\n  twitter: $sb-twitter,\r\n  google: $sb-google,\r\n  mix: $sb-mix,\r\n  line: $sb-line,\r\n  linkedin: $sb-linkedin,\r\n  pinterest: $sb-pinterest,\r\n  reddit: $sb-reddit,\r\n  tumblr: $sb-tumblr,\r\n  whatsapp: $sb-whatsapp,\r\n  messenger: $sb-messenger,\r\n  telegram: $sb-telegram,\r\n  xing: $sb-xing,\r\n  sms: $sb-sms,\r\n  email: $sb-email,\r\n  viber: $sb-viber,\r\n  vk: $sb-vk,\r\n  copy: $sb-copy,\r\n  print: $sb-print,\r\n  expand: $sb-expand\r\n) !default;\r\n","@import \"variables\";\r\n\r\n.sb-default .sb-wrapper {\r\n  --sb-color: #{$sb-accent};\r\n  --sb-background: var(--button-color);\r\n  --sb-border-radius: 4px;\r\n  --sb-overflow: hidden;\r\n\r\n  &.sb-show-icon.sb-show-text {\r\n    --sb-text-padding: 0 1em 0 0;\r\n\r\n    .sb-text {\r\n      filter: none;\r\n    }\r\n  }\r\n}\r\n","@import \"variables\";\r\n\r\n$sb-text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);\r\n$sb-text-size: 0.8em;\r\n\r\n.sb-circles-dark, .sb-circles-light {\r\n  .sb-wrapper {\r\n    --sb-color: #{$sb-accent};\r\n    --sb-background: transparent;\r\n    --sb-min-width: fit-content;\r\n    --sb-height: fit-content;\r\n    --sb-icon-size: 1.4em;\r\n\r\n    &:active {\r\n      .sb-icon {\r\n        box-shadow: 0 7px 8px -4px rgba(0, 0, 0, .2), 0 12px 17px 2px rgba(0, 0, 0, .14), 0 5px 22px 4px rgba(0, 0, 0, .12);\r\n      }\r\n    }\r\n\r\n    .sb-icon {\r\n      background-color: var(--button-color);\r\n      box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12);\r\n      width: 2.5em;\r\n      min-height: 2.5em;\r\n      border-radius: 50%;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-text {\r\n      color: var(--button-color);\r\n      font-size: $sb-text-size;\r\n      margin-top: 5px;\r\n      border-radius: 1em;\r\n      width: 100%;\r\n      height: 1.8em;\r\n      line-height: 1.8em;\r\n      padding: 0;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-content {\r\n      align-items: center;\r\n      flex-direction: column;\r\n    }\r\n  }\r\n}\r\n\r\n.sb-circles-dark .sb-wrapper {\r\n\r\n  .sb-icon {\r\n    background-color: var(--button-color);\r\n  }\r\n\r\n  .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n}\r\n\r\n.sb-circles-light .sb-wrapper {\r\n\r\n  .sb-icon, .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n\r\n  .sb-icon {\r\n    background: radial-gradient(ellipse farthest-corner at center, white 30%, darken(white, 5%) 100%);\r\n  }\r\n}\r\n","\n@import \"../node_modules/ngx-sharebuttons/themes/default.scss\";\n@import \"../node_modules/ngx-sharebuttons/themes/circles.scss\";\n\n/* You can add global styles to this file, and also import other style files */\n\nbody, html {\nheight: 100vh;\n// width: 100vh;\nmargin: 0;\n}\n\nbody {\n    font-family: Arial, sans-serif;\n    height: 100vh;\n    background-color: #fff; /* Background color for the top half */\n    position: relative;\n    display: block;\n    justify-content: center;\n    align-items: center;\n    }\n\n\nbody::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 50%;\n    background: #fff;\n\n\n    z-index: -1; /* Ensure the gradient is behind other content */\n}\n\n\n$theme-back: #2D2D2A;\n/* Old palette\n$theme-main: #B05995;\n$theme-contrast: #3792BF;\n$theme-1: #282B59;\n$theme-2: #D683DD;\n$theme-3: #27567A;\n$theme-4: #44DDC4;\n$theme-5: #3336AE;\n$theme-6: #18C43D;\n*/\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$theme-primary: #3792BF;\n$theme-secondary: #1B3E78;\n$theme-color3: #AACCFF;\n$theme-color4: #BDBDBD;\n$theme-color5: #7D7979;\n$theme-accent: #0CAD99;\n$text-gray:#787c95;\n$theme-red:#d9534f;\n\n$theme-back-light: #4c4c47;\n$theme-lightgray: #e7e7e7;\n$theme-gray-text: #787476;\n\n$theme-table-header: #f6f6f6;\n$theme-table-body:#f8f8f8;\n$theme-source:#9E9E9E;\n\n\n$value-chain-1: #44DDC4;\n$value-chain-2: \"\";\n$value-chain-3: \"\";\n$value-chain-4: \"\";\n\n.material-symbols-outlined {\n\n    cursor: pointer;\n    font-variation-settings:\n        'FILL' 0,\n        'wght' 400,\n        'GRAD' 0,\n        'opsz' 48;\n}\n\np {\n    font-family:Arial, Helvetica, sans-serif;\n    text-align: justify;\n    color: $theme-back;\n}\n\n\n\nhtml, body { height: 100%; }\nbody { margin: 0; font-family: Roboto, \"Helvetica Neue\", sans-serif; }\n\n\n.generic-button, .generic-button-alt {\n  color: white;\n  border-radius: 5px;   /* Rounded corners */\n    padding: 10px 20px;    /* Padding for button size */\n    margin-right: 10px;\n\n    // font-size: 16px;       /* Font size */\n    cursor: pointer;       /* Pointer on hover */\n    transition: background-color 0.3s; /* Smooth transition on hover */\n\n    p {\n        color:white;\n        margin:0;\n    }\n}\n.generic-button {\n  background-color: $theme-main; /* Button background color */\n  border: 2px solid $theme-main;      /* No border */\n}\n\n.generic-button-alt {\n  background-color: $theme-accent; /* Button background color */\n  border: 2px solid $theme-accent;      /* No border */\n}\n\n.generic-button:hover {\n    background-color: #fff; /* Change color on hover */\n    color: $theme-main;\n\n    p {\n        color: $theme-main\n    }\n}\n\n.generic-button-alt:hover {\n  background-color: #fff; /* Change color on hover */\n  color: $theme-accent;\n\n  p {\n    color: $theme-accent\n  }\n}\n\n.generic-button:disabled, .generic-button-alt:disabled {\n    background-color: $theme-lightgray;\n    border-color: $theme-lightgray;\n    cursor:not-allowed;\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
